import React from 'react';
import './DigitalExperience.css';
//import carimg from '../../assets/images/carimg.svg';
//import hostportal from '../../assets/images/hostportal.svg'
function DigitalExperience() {
    //const [videoSrc, setVideoSrc] = useState('/img/videos/default.mp4');

    // const handleImageClick = (src) => {
    //     setVideoSrc(src);
    // };

    return (
        <>
            <section id="customizable" className="digital-experience">
                <div className="container hoversection">
                    <div className="row align-items-end pt-0">
                        <div className="col-xl-9 col-lg-9 col-md-7 px-0">
                            <div className="row">
                                <div className="col-12 text-start p-0 px-0">
                                    <h6 className="">YOUR BRAND OUR TECH</h6>
                                    <h2 className="digitalDesktop">Fully <span className="text-bg">branded digital experience</span></h2>
                                    <h2 className="digitalMobile">Fully <span className="text-bg">branded digital</span><span className="text-bg">experience</span></h2>
                                    <p className="subtitle">
                                        Bring your brand to life with customizable, branded 
                                        experiences for desktop, mobile, and app. It's all included.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-3 col-lg-3 col-md-5">
                            <p className="text-start mb-0 px-0">
                                Custom Journeys That Are
                                Simple To Use And Understand.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container-fluid hoverimages">
                    <div className="row align-items-end px-0">
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-md-6 mobile-app">
                                    <img
                                        // src="/img/App.jpg"
                                        src='/img/hostframe.webp'
                                        alt="App"
                                        className="w-100 hover-animate img-fluid"
                                        // onClick={() => handleImageClick('/img/videos/user_app.mp4')}
                                        // data-bs-toggle="modal"
                                        // data-bs-target="#videoModal"
                                    />
                                </div>
                                {/* <div className="col-md-6 web-app">
                                    <img
                                        src="/img/thankyou-1.webp"
                                        alt="A smartphone screen displays a thank you message from 'Rental Brand' for a vehicle booking. The message reads, "Dear Jane Doe, Thank you for choosing Rental Brand for your vehicle rental needs. Your booking has been successfully received, and we're excited to assist you."
                                        className="w-100 hover-animate"
                                        onClick={() => handleImageClick('/img/videos/mobileapp.mp4')}
                                        data-bs-toggle="modal"
                                        data-bs-target="#videoModal"
                                    />
                                </div> */}
                                <div className="col-md-6 web-app">
                                    <img 
                                    // src="/img/MOBILE.jpg" alt="" 
                                      src="/img/mob_img.webp" alt="" 
                                    className="w-100 hover-animate img-fluid" 
                                    // data-bs-toggle="modal" 
                                    // data-bs-target="#mobileModal" 
                                    />
                                </div>
                                
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="row align-items-end">
                                <div className="col-md-6 host-website">
                                    <img
                                      src='/img/host_website.webp'
                                        alt="Guest"
                                        className="w-100 hover-animate img-fluid"
                                        // onClick={() => handleImageClick('/img/videos/website-mac.mp4')}
                                        // data-bs-toggle="modal"
                                        // data-bs-target="#videoModal"
                                    />
                                </div>
                                <div className="col-md-6 host-portal">
                                    <img
                                        // src="/img/Host portal.jpg"
                                        src='/img/host-portal.webp'
                                        alt="Host Portal"
                                        className="w-100 hover-animate img-fluid"
                                        // onClick={() => handleImageClick('/img/videos/ipad-video.mp4')}
                                        // data-bs-toggle="modal"
                                        // data-bs-target="#videoModal"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="modal fade" id="videoModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content position-relative">
                            <button type="button" className="btn-close video-close-btn" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div className="modal-body p-0 rounded-5">
                                <video key={videoSrc} width="100%" controls autoPlay muted playsInline loop>
                                    <source src={videoSrc} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="mobileModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-mobile modal-dialog-centered">
                        <div className="modal-content position-relative">
                        <button type="button" className="btn-close video-close-btn" data-bs-dismiss="modal" aria-label="Close">
                        </button>
                        <div className="modal-body p-0 rounded-5">
                            <video width="100%" controls autoPlay muted playsInline loop>
                                <source src="/img/videos/mobileapp.mp4" type="video/mp4" />
                            </video>
                        </div>
                        </div>
                    </div>
                </div> */}
            </section>

            <section id="seven-mobile" className="d-lg-none d-md-none d-block">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                        <img
                            src='/img/hostframe.webp'
                            alt="App"
                            // onClick={() => handleImageClick('/img/videos/user_app.mp4')}
                            // data-bs-toggle="modal"
                            // data-bs-target="#videoModal"
                            style={{ width: '62%' }}
                        />
                            {/* <img src="/img/app-m.webp" alt="A smartphone screen showing a car rental app. The screen displays a rental option for Rental Brand, with details like a 4.5 star rating, price range of $30 to $1500, and location in Los Angeles, CA. Icons indicate services such as protection plans, vehicle delivery, and pets allowed.
" style={{ width: '62%' }} /> */}
                        </div>
                        <div className="col-12 text-start">
                            <div className="device-name">App</div>
                            <div className="title">
                                <h3>Title</h3>
                                <p>Description</p>
                                <h5>Boost Your Bookings</h5>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 text-center">
                            <img src="/img/mob_img.webp"
                             alt="Mobile" 
                             style={{ width: '62%' }}  
                            //  data-bs-toggle="modal" 
                            //  data-bs-target="#mobileModal" 
                             />
                            
                        </div>
                        <div className="col-12 text-start">
                            <div className="device-name">Mobile</div>
                            <div className="title">
                                <h3>Title</h3>
                                <p>Description</p>
                                <h5>Boost Your Bookings</h5>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 text-center">
                            {/* <img src="/img/pad-m.webp" alt="A tablet screen displays a car rental website for "Rental Brand." The homepage features a woman driving a car through a scenic route, with mountains visible in the background. The text promotes discovering the perfect rental and includes options to manage bookings and search vehicles.
" className="w-100" /> */}
                            <img
                               src='/img/host_website.webp'
                                alt="Guest"
                                className="w-100"
                                // onClick={() => handleImageClick('/img/videos/website-mac.mp4')}
                                // data-bs-toggle="modal"
                                // data-bs-target="#videoModal"
                            />
                        </div>
                        <div className="col-12 text-start">
                            <div className="device-name">Host Website</div>
                            <div className="title">
                                <h3>Title</h3>
                                <p>Description</p>
                                <h5>Boost Your Bookings</h5>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 text-center px-0">
                            {/* <img src="/img/mac-m.webp" alt="A laptop screen displays a car rental booking requests page. The screen shows a list of car bookings, their statuses (Approved, Declined, Pending), and options to view details. The sidebar menu lists categories: All, Upcoming, On Trip, Completed, and Canceled.
" className="w-100" /> */}
                            <img
                               src='/img/host_portal.png'
                                alt="MacBook Pro"
                                className="w-100"
                                // onClick={() => handleImageClick('/img/videos/ipad-video.mp4')}
                                // data-bs-toggle="modal"
                                // data-bs-target="#videoModal"
                            />
                        </div>
                        <div className="col-12 text-start">
                            <div className="device-name">MacBook Pro</div>
                            <div className="title">
                                <h3>Title</h3>
                                <p>Description</p>
                                <h5>Boost Your Bookings</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default DigitalExperience;
